var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdsIconTogglesFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "normal",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "wasm-icon-fill",
    d: "m2.09,14.34h59.83v13.31c0,1.71-1.39,3.1-3.1,3.1H5.19c-1.71,0-3.1-1.39-3.1-3.1v-13.31h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "wasm-icon-fill",
    d: "m7.59,36.57h49.2c1.23,0,2.24,1,2.24,2.24v12.6H4.97v-12.21c0-1.45,1.18-2.63,2.63-2.63Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdsIconTogglesFront);
export default __webpack_public_path__ + "static/media/SDS_icon_Toggles_Front.0eefd29ac5eb22e6585f88e0e93ba668.svg";
export { ForwardRef as ReactComponent };